import React from 'react'
import PropTypes from 'prop-types'
import renderHTML from 'react-render-html'

import './renderHTML.component.scss'

const RenderHTML = (props) => {
  const { html } = props

  return (
    <div className='render-html'>
      {renderHTML(html)}
    </div>
  )
}

RenderHTML.propTypes = {
  html: PropTypes.string.isRequired
}

export default RenderHTML
